import Home from "../home";
import SignUp from "./sign-up";
import SignIn from "./sign-in";
import Verify from "./verify";
import ForgotPassword from "./forgot-password";
import ResetPassword from "./reset-password";
import Onboarding from "./onboarding";

export {
  Home,
  SignUp,
  SignIn,
  Verify,
  ForgotPassword,
  ResetPassword,
  Onboarding,
};
